import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PaymentMethodModel } from '../models/payment-method.model';
import { PaymentMethodService } from '../services/payment-method.service';

@Injectable()
export class PayablePaymentMethodsResolver  {

    constructor(private service: PaymentMethodService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<PaymentMethodModel>> {
        return this.service.GetPayablePaymentMethods();
    }
}
